import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const ENCRYPTED_FILES = [
    'C:\\Users\\Partner\\Documents\\Client_Files\\Johnson_Trust_Deed.docx',
    'C:\\Users\\Partner\\Documents\\Client_Files\\Pemberton_Accounts_2024.xlsx',
    'C:\\Users\\Partner\\Documents\\Client_Files\\CONFIDENTIAL_Merger_Details.pdf',
    'C:\\Users\\Partner\\Documents\\Client_Database_FULL.accdb',
    'C:\\Users\\Partner\\Documents\\HR\\Staff_Payroll_Records.xlsx',
    'C:\\Users\\Partner\\Documents\\HR\\Employee_NI_Numbers.csv',
    'C:\\Users\\Partner\\Desktop\\Tax_Returns_2024\\CT600_Draft.pdf',
    'C:\\Users\\Partner\\Desktop\\Tax_Returns_2024\\VAT_Q4_Submission.xlsx',
    'C:\\Shared\\Legal\\Client_Contracts\\Contract_00847_Signed.pdf',
    'C:\\Shared\\Legal\\Client_Contracts\\NDA_Hartwell_Investment.docx',
    'C:\\Shared\\Finance\\Bank_Statements\\HSBC_Dec_2024.pdf',
    'C:\\Shared\\Finance\\Invoices_Unpaid\\INV-2024-0893.pdf',
    'C:\\Shared\\Finance\\Invoices_Unpaid\\INV-2024-0921.pdf',
    'C:\\Shared\\CRM\\Client_Master_List.xlsx',
    'C:\\Shared\\CRM\\Pipeline_Q1_2025.xlsx',
    'C:\\Backup\\Server_Backup_Jan2025.bak',
    'C:\\Backup\\SQL_ClientDB_Full.bak',
    'C:\\Users\\Receptionist\\Documents\\Supplier_Details.xlsx',
    'C:\\Users\\Receptionist\\Documents\\Insurance_Policy_2024.pdf',
    'C:\\Program Files\\Sage\\Data\\CompanyData.001',
];

function CommandPrompt({ onClose }) {
    const [lines, setLines] = useState([
        'Microsoft Windows XP [Version 5.1.2600]',
        '(C) Copyright 1985-2001 Microsoft Corp.',
        '',
        'C:\\> ',
    ]);
    const [phase, setPhase] = useState('scanning');
    const [fileIndex, setFileIndex] = useState(0);
    const scrollRef = useRef(null);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [lines]);

    useEffect(() => {
        if (phase === 'scanning') {
            const t = setTimeout(() => {
                setLines(prev => [...prev, 'dir /s /b C:\\Users\\*.* C:\\Shared\\*.* C:\\Backup\\*.*', '', 'Scanning file system...', '']);
                setPhase('encrypting');
            }, 1500);
            return () => clearTimeout(t);
        }
        if (phase === 'encrypting') {
            if (fileIndex < ENCRYPTED_FILES.length) {
                const t = setTimeout(() => {
                    const file = ENCRYPTED_FILES[fileIndex];
                    setLines(prev => [...prev, `[ENCRYPTING] ${file}.LOCKED`]);
                    setFileIndex(i => i + 1);
                }, 300 + Math.random() * 400);
                return () => clearTimeout(t);
            } else {
                const t = setTimeout(() => setPhase('ransom'), 800);
                return () => clearTimeout(t);
            }
        }
        if (phase === 'ransom') {
            setLines(prev => [
                ...prev,
                '',
                '========================================',
                '',
                '  ALL YOUR FILES HAVE BEEN ENCRYPTED',
                '',
                '  Total files locked: ' + ENCRYPTED_FILES.length,
                '  Encryption: AES-256 + RSA-2048',
                '',
                '  To recover your data, transfer',
                '  2.5 BTC to the following wallet:',
                '  bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh',
                '',
                '  You have 72 hours.',
                '',
                '========================================',
                '',
                '',
                '  Think this could never happen to you?',
                '',
                '  Dead Simple Computing',
                '  Anti-Ransomware & Backup Solutions',
                '',
                '  - Immutable cloud backups',
                '  - Endpoint Detection & Response (EDR)',
                '  - Managed Detection & Response (MDR)',
                '  - 24/7 security monitoring',
                '  - Incident response planning',
                '  - Cyber Essentials certification',
                '',
                '  Call: 0118 359 2220',
                '  deadsimplecomputing.co.uk',
                '',
                '  Because "it won\'t happen to us"',
                '  is not a security strategy.',
                '',
            ]);
            setPhase('done');
        }
    }, [phase, fileIndex]);

    return (
        <Div>
            <div className="cmd__content" ref={scrollRef}>
                {lines.map((line, i) => (
                    <div key={i} className={`cmd__line ${line.includes('ENCRYPTING') ? 'cmd__line--red' : ''} ${line.includes('ALL YOUR FILES') ? 'cmd__line--red cmd__line--bold' : ''} ${line.includes('Dead Simple') ? 'cmd__line--green' : ''} ${line.includes('Call:') ? 'cmd__line--green cmd__line--bold' : ''}`}>
                        {line || '\u00A0'}
                    </div>
                ))}
                {phase === 'encrypting' && <span className="cmd__cursor">_</span>}
            </div>
        </Div>
    );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #000;
  font-family: 'Lucida Console', 'Courier New', monospace;
  font-size: 13px;
  color: #c0c0c0;

  .cmd__content {
    flex: 1;
    overflow-y: auto;
    padding: 8px 10px;
  }
  .cmd__line {
    line-height: 1.4;
    white-space: pre-wrap;
    word-break: break-all;
  }
  .cmd__line--red {
    color: #ff4444;
  }
  .cmd__line--green {
    color: #44ff44;
  }
  .cmd__line--bold {
    font-weight: bold;
  }
  .cmd__cursor {
    color: #c0c0c0;
    animation: blink 0.8s infinite;
  }
  @keyframes blink {
    0%, 49% { opacity: 1; }
    50%, 100% { opacity: 0; }
  }
`;

export default CommandPrompt;
